import { DoorConfiguration as contex } from '../DoorConfiguration';
import * as helper from './Shared';
import store from '@/store/index';
import '../types';
import { Characteristic, ValueDefinition } from '../types';
import * as Cylinder from './CylinderCharacteristic.LLT';

// KTU_MM_ZYLINDERLAENGE_INNEN, KTU_MM_ZYLINDERLAENGE_AUSSEN
export const calculateCylinderLength = (): any => {
    const result: any = {
        cylinderLengthInside: 0,
        cylinderLengthOutside: 0,
    };

    let widthValueOpeningSide: number = 0;
    let widthValueCounterOpeningSide: number = 0;

    const doubleWidthLayer = Number(helper.GetMainCharacteristicValue('CUST_MM_AUFDOPPLUNG', contex.Functions));

    const decorOperningSide = helper.GetDependencyValueCode('KTU_MM_ZIERLEISTENVAR_BS', contex.ExteriorAccessory);
    const decorCounterOperningSide = helper.GetDependencyValueCode('KTU_MM_ZIERLEISTENVAR_GBS', contex.ExteriorAccessory);

    const fittingArt = helper.GetDependencyValueCode('KTU_MM_BESCHLAGSART', contex.ExteriorAccessory);
    const doorModel = helper.GetDependencyValueCode('KTU_MM_MODELL', contex.ModelSelection);
    const doorWings = helper.GetDependencyValueCode('KTU_MM_OEFFNUNGSART', contex.ModelSelection);
    const openingSide = helper.GetDependencyValueCode('KTU_MM_AUFGEHRICHTUNG', contex.Functions);

    widthValueOpeningSide = decorOperningSide !== 'ZV0' ? doubleWidthLayer : 0;
    widthValueCounterOpeningSide = decorCounterOperningSide !== 'ZV0' ? doubleWidthLayer : 0;

    switch (fittingArt) {
        case 'STANDARD BESCHLAG':
        case 'ALT WIEN BESCHLAG':
        case 'BESCHLAG EN179 FKT E':
        case 'BESCHLAG EN179 FKT B':
            switch (doorModel) {
                case 'CERT':
                    switch (doorWings) {
                        case 'D1':
                            result.cylinderLengthInside = widthValueOpeningSide + 40;
                            result.cylinderLengthOutside = widthValueCounterOpeningSide + 30;
                            break;
                        case 'D2':
                            result.cylinderLengthInside = widthValueOpeningSide + 35;
                            result.cylinderLengthOutside = widthValueCounterOpeningSide + 35;
                            break;
                    }
                    break;
                case 'BERT':
                case 'VERT':
                    switch (openingSide) {
                        case 'LI':
                        case 'RI':
                            switch (doorWings) {
                                case 'D1':
                                    result.cylinderLengthInside = widthValueOpeningSide + 55;
                                    result.cylinderLengthOutside = widthValueCounterOpeningSide + 45;
                                    break;
                                case 'D2':
                                    result.cylinderLengthInside = widthValueOpeningSide + 50;
                                    result.cylinderLengthOutside = widthValueCounterOpeningSide + 50;
                                    break;
                            }
                            break;
                        case 'LA':
                        case 'RA':
                            switch (doorWings) {
                                case 'D1':
                                    result.cylinderLengthInside = widthValueCounterOpeningSide + 40;
                                    result.cylinderLengthOutside = widthValueOpeningSide + 60;
                                    break;
                                case 'D2':
                                    result.cylinderLengthInside = widthValueCounterOpeningSide + 45;
                                    result.cylinderLengthOutside = widthValueOpeningSide + 55;
                                    break;
                            }
                            break;
                    }
                    break;
            }
            break;
        case 'BESCHLAG BAUSEITIG':
        case 'BESCHLAG NACH ABSPRACHE':
            switch (doorModel) {
                case 'CERT':
                    switch (doorWings) {
                        case 'D1':
                            result.cylinderLengthInside = widthValueOpeningSide + 31;
                            result.cylinderLengthOutside = widthValueCounterOpeningSide + 15;
                            break;
                        case 'D2':
                            result.cylinderLengthInside = widthValueOpeningSide + 27;
                            result.cylinderLengthOutside = widthValueCounterOpeningSide + 19;
                            break;
                    }
                    break;
                case 'BERT':
                case 'VERT':
                    switch (openingSide) {
                        case 'LI':
                        case 'RI':
                            switch (doorWings) {
                                case 'D1':
                                    result.cylinderLengthInside = widthValueOpeningSide + 47;
                                    result.cylinderLengthOutside = widthValueCounterOpeningSide + 29;
                                    break;
                                case 'D2':
                                    result.cylinderLengthInside = widthValueOpeningSide + 41;
                                    result.cylinderLengthOutside = widthValueCounterOpeningSide + 35;
                                    break;
                            }
                            break;
                        case 'LA':
                        case 'RA':
                            switch (doorWings) {
                                case 'D1':
                                    result.cylinderLengthInside = widthValueCounterOpeningSide + 29;
                                    result.cylinderLengthOutside = widthValueOpeningSide + 47;
                                    break;
                                case 'D2':
                                    result.cylinderLengthInside = widthValueCounterOpeningSide + 35;
                                    result.cylinderLengthOutside = widthValueOpeningSide + 41;
                                    break;
                            }
                            break;
                    }
                    break;
            }
            break;
        default:
            break;
    }

    return result;
};


// KTU_MM_ZYLINDER
export const getZylinderLLTValue = (): ValueDefinition => {
    let lltNumber: string = '0';

    const cylinderType = helper.GetDependencyValueCode('CUST_MM_ZYLINDER', contex.ExteriorAccessory);
    const doorModel = helper.GetDependencyValueCode('KTU_MM_MODELL', contex.ModelSelection);

    const cylinderLength = calculateCylinderLength();
    const lengthInside = cylinderLength.cylinderLengthInside;
    const lengthOutside = cylinderLength.cylinderLengthOutside;

    switch (cylinderType) {
        case '1': // bauseitig beigestellt
            switch (doorModel) {
                case 'BERT':
                case 'VERT':
                    lltNumber = '0';
                    break;
                case 'CERT':
                    lltNumber = '0';
                    break;
            }
            break;
        case '2': // Zylinder Silber beidseitig sperrbar
            switch (doorModel) {
                    case 'BERT':
                    case 'VERT':
                        lltNumber = Cylinder.ZBeidseitigSperrbar(doorModel, lengthInside, lengthOutside);
                        break;
                    case 'CERT':
                        lltNumber = Cylinder.ZBeidseitigSperrbar(doorModel, lengthInside, lengthOutside);
                        break;
                }
            break;
        case '3': // Zylinder Silber mit Knauf Silber
            switch (doorModel) {
                    case 'BERT':
                    case 'VERT':
                        lltNumber = Cylinder.ZMitKnauf(doorModel, lengthInside, lengthOutside);
                        break;
                    case 'CERT':
                        lltNumber = Cylinder.ZMitKnauf(doorModel, lengthInside, lengthOutside);
                        break;
                }
            break;
        case '4': // Zylinder Silber mit Knauf Messing
            switch (doorModel) {
                    case 'BERT':
                    case 'VERT':
                        lltNumber = Cylinder.ZMitKnauf(doorModel, lengthInside, lengthOutside);
                        break;
                    case 'CERT':
                        lltNumber = Cylinder.ZMitKnauf(doorModel, lengthInside, lengthOutside);
                        break;
                }
            break;
        case '5': // Dummy
            switch (doorModel) {
                    case 'BERT':
                    case 'VERT':
                        lltNumber = 'LLT510133';
                        break;
                    case 'CERT':
                        lltNumber = 'LLT510133';
                        break;
                }
            break;
        case '6': // Baustellen - Zylinder beidseitig sperrbar
            switch (doorModel) {
                    case 'BERT':
                    case 'VERT':
                        // CHECK FOR SONDER
                        lltNumber = 'LLT510131';
                        break;
                    case 'CERT':
                        // CHECK FOR SONDER
                        lltNumber = 'LLT510130';
                        break;
                }
            break;
        case '7': // Freilaufzylinder bauseitig beigestellt
            switch (doorModel) {
                    case 'BERT':
                    case 'VERT':
                        lltNumber = '0';
                        break;
                    case 'CERT':
                        lltNumber = '0';
                        break;
                }
            break;
        case '8': // Freilaufzylinder silber beidseitig sperrbar
            switch (doorModel) {
                    case 'BERT':
                    case 'VERT':
                        lltNumber = Cylinder.FZBeidseitigSperrbar(doorModel, lengthInside, lengthOutside);
                        break;
                    case 'CERT':
                        lltNumber = Cylinder.FZBeidseitigSperrbar(doorModel, lengthInside, lengthOutside);
                        break;
                }
            break;
        case '9': // Freilaufzylinder silber mit Drehrad silber
            switch (doorModel) {
                    case 'BERT':
                    case 'VERT':
                        lltNumber = Cylinder.FZMitDrehrad(doorModel, lengthInside, lengthOutside);
                        break;
                    case 'CERT':
                        lltNumber = Cylinder.FZMitDrehrad(doorModel, lengthInside, lengthOutside);
                        break;
                }
            break;
        case '10': // Freilaufzylinder silber mit Drehrad Messing
            switch (doorModel) {
                    case 'BERT':
                    case 'VERT':
                        lltNumber = Cylinder.FZMitDrehrad(doorModel, lengthInside, lengthOutside);
                        break;
                    case 'CERT':
                        lltNumber = Cylinder.FZMitDrehrad(doorModel, lengthInside, lengthOutside);
                        break;
                }
            break;
        default:
            lltNumber = '0';
            break;
    }


    let cylinderCharacteristic: any;
    let cylinderValue: ValueDefinition;

    // if (lltNumber !== '0') {
    cylinderCharacteristic = store.state.exteriorAccessoryModule.model.characteristics.filter((c: any) => c.code === 'KTU_MM_ZYLINDER')[0];
    cylinderValue = cylinderCharacteristic.values.filter((v: ValueDefinition) => v.value === lltNumber)[0];
    // } else {
    //     cylinderValue = {
    //         id: 0,
    //         default: 0,
    //         description: '0',
    //         value: '0',
    //         resource: '',
    //     };
    // }

    // if (typeof cylinderValue === 'undefined') {
    //     cylinderValue = {
    //         id: 0,
    //         default: 0,
    //         description: '0',
    //         value: '0',
    //         resource: '',
    //     };
    // }

    return cylinderValue;
};